  // ==========================================
  // 2. コレクションページ用のUI制御（絞り込み・表示）
  // ==========================================
  let currentCategory = 'WATCH';
  let currentBrand = 'ALL';
  window.currentModalId = null;

  // ★ ヘッダーより先にコレクション一覧が読み込まれた場合の対策（お気に入り機能の保持）
  if (typeof window.wishlist === 'undefined') {
    let saved = localStorage.getItem('wwjf_wishlist');
    let parsed = [];
    try {
      if (saved) {
         let tmp = JSON.parse(saved);
         if (Array.isArray(tmp)) parsed = tmp;
      }
    } catch(e) {}
    window.wishlist = new Set(parsed);
  }

  // ★ renderCatalogGrid で参照できるようにローカル変数に格納
  let wishlist = window.wishlist;

  // スクロールでフェードイン
  const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('is-visible'); });
  }, { threshold: 0.1 });
  document.querySelectorAll('.fade-up').forEach(el => observer.observe(el));


  // 初期表示
  updateBrandFilterUI();
  renderCatalogGrid();

  function selectCategory(category, btnEl) {
    currentCategory = category;
    currentBrand = 'ALL';
    document.querySelectorAll('#categoryTabs .category-tab').forEach(t => t.classList.remove('is-active'));
    const target = btnEl || document.querySelector(`#categoryTabs .category-tab[data-category="${category}"]`);
    if (target) target.classList.add('is-active');
    
    // ボトムシートのタイトル変更
    if (category === 'JEWELRY') {
      document.getElementById('brandSheetTitle').innerText = 'ジュエリーブランドで絞り込む';
    } else {
      document.getElementById('brandSheetTitle').innerText = '時計ブランドで絞り込む';
    }

    // 特定カテゴリの時はフィルターボタンを非表示
    const filterBar = document.getElementById('brandFilterBar');
    if (filterBar) {
      filterBar.style.display = (category === 'BAG' || category === 'FRAGRANCE' || category === 'CHAMPAGNE') ? 'none' : 'flex';
    }

    updateBrandFilterUI();
    renderCatalogGrid();
  }

  // ブランド絞り込みボトムシート
  function openBrandSheet() {
    renderBrandSheetList();
    const overlay = document.getElementById('brandSheetOverlay');
    const panel = document.getElementById('brandSheetPanel');
    if(overlay && panel) {
        overlay.classList.add('is-open');
        void overlay.offsetWidth;
        panel.classList.add('is-open');
    }
  }

  function closeBrandSheet() {
    const overlay = document.getElementById('brandSheetOverlay');
    const panel = document.getElementById('brandSheetPanel');
    if(panel) panel.classList.remove('is-open');
    if(overlay) setTimeout(() => overlay.classList.remove('is-open'), 300);
  }

  function renderBrandSheetList() {
    const brands = [...new Set(catalogProducts.filter(p => p.category === currentCategory).map(p => p.brand))].sort();
    const list = document.getElementById('brandSheetList');
    if(!list) return;
    let html = `<div class="brand-option ${currentBrand === 'ALL' ? 'is-selected' : ''}" onclick="selectBrandOption('ALL')"><span class="brand-option__radio"></span><span>すべてのブランド</span></div>`;
    brands.forEach(b => {
      html += `<div class="brand-option ${currentBrand === b ? 'is-selected' : ''}" onclick="selectBrandOption('${b}')"><span class="brand-option__radio"></span><span>${b}</span></div>`;
    });
    list.innerHTML = html;
  }

  function selectBrandOption(brand) {
    currentBrand = brand;
    closeBrandSheet();
    updateBrandFilterUI();
    renderCatalogGrid();
  }

  function updateBrandFilterUI() {
    const trigger = document.getElementById('brandFilterTrigger');
    const tagWrap = document.getElementById('brandFilterTags');
    const brandTitleEl = document.querySelector('.brand-title');
    
    if (currentBrand === 'ALL') {
      if(trigger) {
        trigger.classList.remove('is-active');
        trigger.querySelector('span').innerText = 'ブランドで探す';
      }
      if(tagWrap) tagWrap.innerHTML = '';
      if(brandTitleEl) brandTitleEl.innerText = currentCategory + ' 商品一覧';
    } else {
      if(trigger) {
        trigger.classList.add('is-active');
        trigger.querySelector('span').innerText = '選択中';
      }
      if(tagWrap) tagWrap.innerHTML = `<span class="brand-filter-tag">${currentBrand}<button onclick="selectBrandOption('ALL')">&times;</button></span>`;
      if(brandTitleEl) brandTitleEl.innerText = currentBrand;
    }
  }

  function renderCatalogGrid() {
    const grid = document.getElementById('catalogGrid');
    if(!grid) return;
    const items = catalogProducts.filter(p => p.category === currentCategory && (currentBrand === 'ALL' || p.brand === currentBrand));
    if (items.length === 0) {
      grid.innerHTML = '<p class="catalog-empty">該当する商品が見つかりませんでした。</p>';
      return;
    }
    let html = '';
    items.forEach(p => {
      const item = window.db[p.id];
      if (!item) return;
      
      const liked = window.wishlist && window.wishlist.has(p.id) ? 'is-liked' : '';
      
      let badgesHtml = '';
      if (p.isNew || p.limitedText) {
        badgesHtml += `<div class="catalog-item__badges">`;
        if (p.isNew) {
            badgesHtml += `<span class="catalog-item__badge catalog-item__badge--new">NEW</span>`;
        }
        if (p.limitedText) {
            badgesHtml += `<span class="catalog-item__badge catalog-item__badge--limited">${p.limitedText}</span>`;
        }
        badgesHtml += `</div>`;
      }

      html += `
        <div class="catalog-item" data-category="${p.category}" data-brand="${p.brand}">
          <div class="catalog-item__media catalog-item__media--square" onclick="openProductModal('${p.id}')">
            <img src="${item.img}" alt="${item.brand} ${item.title}">
            <button class="like-btn ${liked}" onclick="toggleLike(event,'${p.id}')"><svg width="16" height="16" viewBox="0 0 24 24"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg></button>
          </div>
          <div onclick="openProductModal('${p.id}')" style="cursor:pointer;">
            <p class="catalog-item__brand">${item.brand}</p>
            <h3 class="catalog-item__name">${item.title}</h3>
            <p class="catalog-item__price">${item.price}</p>
            ${badgesHtml}
          </div>
        </div>`;
    });
    grid.innerHTML = html;
  }

  // ==========================================
  // 3. モーダル・いいね連携処理
  // ==========================================
  
  function showToast(msg) {
    const toast = document.getElementById('toast');
    if(toast) {
        toast.innerText = msg;
        toast.classList.add('is-visible');
        setTimeout(() => toast.classList.remove('is-visible'), 3000);
    }
  }

  // ★ ヘッダーの toggleLike が未定義の場合の保険ラッパー
  if (typeof window.toggleLike === 'undefined') {
      window.toggleLike = function(e, id) {
          if (e) e.stopPropagation();
          const isLiked = window.wishlist.has(id);
          if (isLiked) { window.wishlist.delete(id); showToast('リストから削除しました'); }
          else { window.wishlist.add(id); showToast('気になるリストに追加しました'); }
      
          localStorage.setItem('wwjf_wishlist', JSON.stringify([...window.wishlist]));
      
          document.querySelectorAll(`.like-btn[onclick*="${id}"]`).forEach(btn => {
            btn.classList.toggle('is-liked', !isLiked);
          });
      
          const countBadge = document.getElementById('headerCount');
          if(countBadge) {
            countBadge.innerText = window.wishlist.size;
            countBadge.classList.toggle('is-hidden', window.wishlist.size === 0);
          }
      
          if (window.currentModalId === id && typeof window.updateModalButtonState === 'function') {
              window.updateModalButtonState();
          }
          
          if(typeof renderDrawerItems === 'function') {
              renderDrawerItems();
          }
      };
  }